"use strict";
/**
 * Google Calendar Integration - Response Types
 *
 * Response contracts for the Google Calendar diagnostic feature.
 * See: resources/notes/google-calendar/standard-v1.md
 */
Object.defineProperty(exports, "__esModule", { value: true });
